// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"daa8ceb3","977":"67b495a0"}[chunkId] + ".chunk.js";
};